import { useCallback } from 'react'
import { useOptionalCommunity } from '@/lib/CommunityContext'
import { useLocale } from '@/lib/LocaleContext'
import { formatMoney, type MoneyDigits } from '@/lib/money'

/** `(value, currency?, digits?) => string`, from `useMoney()`. */
export type MoneyFormatter = (value: number | string | null | undefined, currency?: string | null, digits?: MoneyDigits) => string

/**
 * Money on screen (U4): `formatMoney` with the reader's language and the
 * current community. Without `currency` the value is in the community's
 * currency. Null, empty or not a number reads "—".
 */
export function useMoney(): MoneyFormatter {
  /* No throw outside the provider: a screen outside the community (none today) still formats, by Intl. */
  const community = useOptionalCommunity()
  const { currentLocale } = useLocale()
  const currency = community?.currency
  const currencyFormat = community?.currencyFormat
  return useCallback(
    (value, valueCurrency, digits) => formatMoney(value, valueCurrency, currentLocale, { currency, currencyFormat }, digits),
    [currentLocale, currency, currencyFormat],
  )
}
